import { cn } from "./lib/utils";

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
	className?: string;
}

export function Skeleton({
	className,
	...props
}: SkeletonProps): React.ReactElement {
	return (
		<div
			className={cn(
				"relative h-full w-full animate-shimmer overflow-hidden before:absolute before:inset-0 before:animate-[pulsate_2s_infinite] before:bg-gradient-to-r before:from-surface-shimmer-end before:via-surface-shimmer-start before:to-surface-shimmer-end",
				className,
			)}
			{...props}
		/>
	);
}
